// Format images on blog posts

if (window.location.href.includes("blogs")) {
  const articleLinks = document.querySelectorAll(
    ".article-template__content a"
  );
  if (articleLinks.length > 0) {
    articleLinks.forEach((link) => {
      if (link.querySelector("img")) {
        const parent = link.parentNode;
        parent?.classList.add("article-template__content--image");
      }
    });
  }
}
